<div id="tab-one-b" class="togglegroup margin-top">
  <a class="back u-mb40 toggle global-hand" data-id="tab-one-c" (click)="handleBack.emit()">
    Modificar licencia
  </a>

  <div class="u-bt u-bt--grey">
    <div class="row">
      <div class="col-md-3 u-pt30 u-pb10">
        <h3 class="txt txt--section">
          {{nameAsset}}
        </h3>
        <p class="txt txt--paragraph">
          Nº:{{numberLicense}}
        </p>
        <h5 class="text-styleH5">Restricciones de conducción:</h5>
        <p class="text-styleP">{{ restrictionDriver}}</p>
      </div>

      <div class="col-md-3 u-pt30 u-pb10">
        <a class="modal__trigger delete global-hand" data-modal="modal02"
          (click)="onDeleteLicense(licenseSelectedId)"><img class="delete-action-icon"
            src="/assets/img/icon-delete-orange.png">Eliminar</a>
      </div>
    </div>

    <div class="table table--license license-cont">
      <div class="thead">
        <div class="tr">
          <div class="th" style="width: 30%"><img class="mr-2" src="assets/img/truck.png">Vehículo</div>
          <div class="th"><img class="mr-2" src="assets/img/local.png">Zonas registradas</div>
          <div class="th"><img class="mr-2" src="assets/img/type_driver.png">Tipo licencia</div>
          <div class="th align-end"><img class="mr-2" src="assets/img/lapiz.png">Acciones</div>
        </div>
      </div>
      <ng-container *ngFor="let vehicle of detailLicense?.equipments;index as vi;">
        <div class="tbody">
          <div class="tr tr--green">
            <div class="td td--button">
              <div>
                <img class="mr-2" src="assets/img/truck.png">
              </div>
              <div>
                <p>{{vehicle.equipmentName }}</p>
                <small>{{vehicle.equipmentBrand }} -
                  {{vehicle.equipmentModel }}</small>
              </div>
            </div>

            <div class="td td--button max-width-zones-rows ">
              <div>

                <ul *ngFor="let zones of vehicle.conductionZones; let index = index;">
                  <li class="list-select">
                    <span>{{zones.description}}</span>
                  </li>
                </ul>
              </div>

            </div>

            <div class="td td--button">
              <div>
                <img class="mr-2" src="assets/img/type_driver.png">
              </div>
              <div>
                <p> {{getDescription(vehicle.licenseTypes) | separatedByCharacter: [', ', ' y '] }} </p>
              </div>
            </div>

            <div class="td td--button align-end">
              <a type="button" class="btn btn--primary action-button-margin" (click)="openForm(vi)">
                Modificar
              </a>
              <a
                type="button"
                class="btn btn--primary action-button-margin"
                [ngClass]="detailLicense?.equipments!.length === 1 ? 'btn--disabled' : ''"
                [attr.disabled]="detailLicense?.equipments!.length > 1 ? null : true"
                (click)="onDeleteEquiment(vehicle.equipmentId)"
              >
                Eliminar
              </a>
            </div>

          </div>
        </div>

        <div class="form-equipment-container" [ngClass]="{
          'container-open': equipmentFormStatus[vi],
          'container-closed': !equipmentFormStatus[vi]
        }">
          <div class="form-equipment-background"
          [ngClass]="{
            'form-equipment-background--opened': equipmentFormStatus[vi],
            'form-equipment-background--closed': !equipmentFormStatus[vi]
          }"
          >
            <div style="padding:40px">
              <app-modify-equipment-form
                colorInputs="WHITE"
                [id]="vehicle.equipmentId"
                [licenseTypes]="vehicle.licenseTypes"
                [conductionZones]="vehicle.conductionZones"
                [brand]="vehicle.equipmentBrand"
                [model]="vehicle.equipmentModel"
                [ngClass]="{
                  'form-equipment-open': equipmentFormStatus[vi],
                  'form-equipment-closed': !equipmentFormStatus[vi]
                }"
                (discardChanges)="closeForm(vi)"
                (modifyEquipment)="onModifyEquipment($event, vi)"
              ></app-modify-equipment-form>
            </div>
          </div>
          <div class="form-equipment-background form-equipment-background-fake"
          [ngClass]="{
            'form-equipment-background--opened': equipmentFormStatus[vi],
            'form-equipment-background--closed': !equipmentFormStatus[vi]
          }"
          >
            <app-modify-equipment-form
              [emptyTitles]="true"
              [licenseTypes]="vehicle.licenseTypes"
              [conductionZones]="vehicle.conductionZones"

            ></app-modify-equipment-form>
          </div>
        </div>
      </ng-container>
    </div>

    <app-modify-dates-form
      @fadeAnimationModifyDates
      *ngIf="documentList && documentList.length > 0 && completeLicenseData"
      [documents]="this.documentList"
      [requirementId]="this.completeLicenseData.requirementId"
      [driverMdmid]="this.completeLicenseData.userRutDv"
      [driverIsEmployee]="driverIsEmployee"
      [assetId]="this.completeLicenseData.asset.id"
      (modifyDates)="this.onModifyDates($event)"
    >

    </app-modify-dates-form>
  </div>
</div>
